/**
 * @file index.tsx
 *
 * @fileoverview Renders blog search page with tags filter.
 */
import BlogsPage, { getServerSideProps } from '~/jobiqo/pages/blogs';
export default BlogsPage;
export { getServerSideProps };
